import request from '@/config/axios'

export interface AgentSoftwareConfigVO {
  id?: number
  softwareId: string
  softwareName?: string
  moduleType?: number
  moduleTypeLabel?: string
  icon?: string
  iconColor?: string
  enabled?: boolean
  ruleId?: number
  ruleVersion?: number
  basis?: string
  rate?: number
  period?: string
  tiersOn?: boolean
  tiersJson?: string
  cap?: number
  floor?: number
  regionExclusiveBonusOn?: boolean
  reBonus?: number
  firstOrderBonusOn?: boolean
  firstOrderBonusMode?: number
  firstOrderBonusAmount?: number
  firstOrderBonusRate?: number
  ruleUpdateTime?: string
  updateTime?: string
}

export interface AgentCommissionRuleVO {
  id?: number
  softwareId?: string
  version?: number
  basis?: string
  rate?: number
  period?: string
  tiersOn?: boolean
  tiersJson?: string
  cap?: number
  floor?: number
  regionExclusiveBonusOn?: boolean
  reBonus?: number
  firstOrderBonusOn?: boolean
  firstOrderBonusMode?: number
  firstOrderBonusAmount?: number
  firstOrderBonusRate?: number
  remark?: string
  createTime?: string
}

export interface AgentSoftwareConfigPageReq {
  pageNo: number
  pageSize: number
  keyword?: string
}

export const getSoftwareConfigPage = (params: AgentSoftwareConfigPageReq) =>
  request.get<{ list: AgentSoftwareConfigVO[]; total: number }>({
    url: '/agent/software-config/page',
    params
  })

export const saveSoftwareConfig = (
  data: Partial<AgentSoftwareConfigVO> & {
    softwareId: string
    enabled: boolean
    basis: string
    rate: number
    period: string
  }
) => request.put({ url: '/agent/software-config/save', data })

/** 仅切换接入开关（写 agent_software_config，不改模块管理） */
export const updateSoftwareEnabled = (softwareId: string, enabled: boolean) =>
  request.put({
    url: '/agent/software-config/enabled',
    params: { softwareId, enabled }
  })

export const getSoftwareRuleHistory = (softwareId: string) =>
  request.get<AgentCommissionRuleVO[]>({
    url: '/agent/software-config/rule-history',
    params: { softwareId }
  })
